import React, { FunctionComponent, PropsWithChildren } from 'react'
import { EsidProvider } from './EsidContext'
import { useFederatedUserJourneySink } from './federationSink'
import { UserJourneySink } from './sink'
import { UserJourneyContext } from './UserJourneyContext'
import { UserJourneyReporting } from './UserJourneyReporting'
import { UserJourneyStateSync } from './UserJourneyStateSync'
import { useUserJourney } from './useUserJourney'

export interface UserJourneyProviderProps {
  /** Overrides the default sink (Datadog + flag-gated Path A federation) — used by tests */
  sink?: UserJourneySink
}

/** Must be mounted inside the Redux Provider (UserJourneyStateSync dispatches to the store, and the federated sink reads the checkout token and LD readiness from it). */
export const UserJourneyProvider: FunctionComponent<PropsWithChildren<UserJourneyProviderProps>> = ({ children, sink }) => {
  const userJourney = useUserJourney()
  const federatedSink = useFederatedUserJourneySink()

  return (
    <EsidProvider>
      <UserJourneyContext.Provider value={userJourney}>
        {/* Order is load-bearing: UserJourneyReporting must mount (and subscribe) before
            any page anchor in {children} dispatches — a resume dispatched before the
            subscription exists would be silently unreported */}
        <UserJourneyStateSync />
        <UserJourneyReporting sink={sink ?? federatedSink} />
        {children}
      </UserJourneyContext.Provider>
    </EsidProvider>
  )
}
